import React from 'react';
import { FormControl, FormLabel, RadioGroup } from '@mui/material';
import IconRadioItem from './IconRadioItem';
import useTranslate from '../../customHooks/useTranslate';
import Icon from '../Icon';
import Tooltip from '../Tooltip';

interface IconRadioGroupProps {
    label?: string;
    options: {
        value: string | number;
        label: string;
        icon: string;
        iconStyle?: React.CSSProperties;
        disabled?: boolean;
    }[];
    value: string | number;
    onChange: (value: string | number) => void;
    onBlur?: () => void;
    error?: boolean;
    errorMessage?: string;
    info?: string | React.ReactNode;
    disabled?: boolean;
}

const IconRadioGroup = (props: IconRadioGroupProps) => {
    const {
        label,
        options,
        value,
        onChange,
        error,
        errorMessage,
        onBlur,
        info,
        disabled,
    } = props;
    const translate = useTranslate();

    return (
        <FormControl sx={{ gap: '10px', width: '100%' }}>
            <div className='flex flex-align-center gap-10'>
                {label && (
                    <FormLabel
                        sx={{
                            fontWeight: 'bold',
                            color: error
                                ? 'var(--error-400)'
                                : 'var(--secondary-700)',
                            fontSize: '14px',
                        }}
                    >
                        {label}
                    </FormLabel>
                )}
                {info && (
                    <Tooltip title={info}>
                        <span>
                            <Icon
                                iconName='InfoOutlined'
                                style={{
                                    fontSize: '14px',
                                    color: 'var(--grey-600)',
                                }}
                            />
                        </span>
                    </Tooltip>
                )}
            </div>
            <RadioGroup
                row
                value={value}
                onChange={e => onChange(e.target.value)}
                onBlur={onBlur}
                sx={{ gap: '10px' }}
            >
                {options.map(option => {
                    return (
                        <IconRadioItem
                            key={option.value}
                            value={option.value}
                            label={option.label}
                            icon={option.icon}
                            iconStyle={option.iconStyle}
                            selected={option.value === value}
                            error={error}
                            disabled={option.disabled || disabled}
                        />
                    );
                })}
            </RadioGroup>
            {error && errorMessage && (
                <span style={{ color: 'var(--error-400)', fontSize: '12px' }}>
                    {translate(errorMessage)}
                </span>
            )}
        </FormControl>
    );
};

export default IconRadioGroup;
